import { attr } from 'spraypaint';
import stringOrNullAttr from '../stringOrNullAttr';
import ApplicationRecord from './ApplicationRecord';

const DiscountCode = ApplicationRecord.extend({
  attrs: {
    discount_code: attr({ persist: false }),
    member_id: stringOrNullAttr(),
  },
  static: {
    endpoint: '/discount_codes',
    jsonapiType: 'vitality_promotions-discount_codes',
  },
});

export default DiscountCode;
